/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemSyncStatusResponseSchema = z.object({
  errorMessage: z.string().nullish(),
  integrationId: z.int().nullish(),
  itemId: z.int(),
  state: z.enum(['PENDING', 'IN_PROGRESS', 'FAILED', 'SYNCED', 'NOT_LINKED']),
});
